<div
  id="kt_charts_widget_3_chart"
  class="position-relative z-index-1 h-350px"
>
  <apx-chart
    [series]="(bigChartStats | appDashboardChartSeries | async) || []"
    [chart]="chartOptions.chart"
    [xaxis]="chartOptions.xaxis"
    [yaxis]="(bigChartStats | appDashboardChartYAxis | async) || []"
    [dataLabels]="chartOptions.dataLabels"
    [labels]="bigChartStats[0]?.dates"
    [stroke]="chartOptions.stroke"
    [legend]="chartOptions.legend"
    [fill]="chartOptions.fill"
    [states]="chartOptions.states"
    [tooltip]="chartOptions.tooltip"
    [colors]="chartOptions.colors"
    [markers]="chartOptions.markers"
    [plotOptions]="chartOptions.plotOptions"
  ></apx-chart>
  <div
    *ngIf="isFakeData"
    class="position-absolute top-0 bottom-0 start-0 end-0"
  >
    <div class="position-absolute top-0 bottom-0 start-0 end-0 bg-white opacity-80"></div>
    <div class="position-absolute top-50 start-50 translate-middle z-index-1 fw-bolder">
      {{'DASHBOARD.LACK_OF_DATA' | translate}}
    </div>
  </div>
</div>
